@if (!isInputMode()) {
<section class="contents__section contents__section--gost-report">
  <div class="header-container">
    <button mat-flat-button (click)="navigateToNewGostPage()" color="primary"
      class="mat-elevation-z0 align-right-button">
      <mat-icon>edit_note</mat-icon>
      <span class="full-text" i18n="@@home.gostDigest.button.manualDataEntry">データ手動入力</span>
    </button>

    @if (!loading && recordData()?.id == gostUtils.newGostId) {
      <div class="gost-input-toolbar gost-input-toolbar--context">
        <div class="gost-input-toolbar__left">
          <mat-form-field appearance="outline" class="gost-input-toolbar__date-field">
            <mat-label i18n="@@home.gostDigest.label.evaluationDateInput">評価日</mat-label>
            <input matInput id="upload_date" (dateChange)="onUploadDateChange()" [matDatepicker]="userpicker0"
              [value]="dateAsDateObject" readonly>
            <mat-datepicker-toggle matSuffix [for]="userpicker0"></mat-datepicker-toggle>
            <mat-datepicker #userpicker0></mat-datepicker>
          </mat-form-field>
          <button mat-stroked-button type="button"
            class="mat-elevation-z0 gost-action-button gost-action-button--copy"
            (click)="copyFromPreviousRecord()"
            [disabled]="!canCopyPreviousValues() || isCopyingPrevious()">
            <mat-icon fontSet="material-icons-outlined">content_copy</mat-icon>
            <span i18n="@@home.gostDigest.button.copyPrevious">前回の値をコピー</span>
          </button>
        </div>
      </div>
    }
  </div>
  @if (loading) {
    <div class="gost-digest-surface">
      <div class="gost-digest-skeleton" role="status" aria-live="polite" aria-busy="true">
              <div class="header">
                <h1 i18n="@@home.gostDigest.title.mealAbilityReport">食事能力のレポート</h1>
                <div class="score_meta">
                  <ul class="score_meta_body">
                    <li class="score_meta_item score_meta_item--date-nav">
                      <span class="label" i18n="@@home.gostDigest.label.evaluationDate">評価日：</span>
                      <span class="value">{{ asOfDate || recordData()?.data?.asOfDate || '-' }}</span>
                      <span class="date-nav-controls">
                        <button
                          mat-icon-button
                          type="button"
                          class="date-nav-button date-nav-button--disabled"
                          disabled
                          i18n-aria-label="@@home.gostDigest.button.previousEvaluationDate"
                          aria-label="前の評価日"
                        >
                          <mat-icon fontSet="material-icons-outlined">chevron_left</mat-icon>
                        </button>
                        <button
                          mat-icon-button
                          type="button"
                          class="date-nav-button date-nav-button--disabled"
                          disabled
                          i18n-aria-label="@@home.gostDigest.button.nextEvaluationDate"
                          aria-label="次の評価日"
                        >
                          <mat-icon fontSet="material-icons-outlined">chevron_right</mat-icon>
                        </button>
                      </span>
                    </li>
                    <li class="score_meta_item">
                      <span class="label" i18n="@@home.gostDigest.label.evaluator">評価者：</span>
                      @if (recordData()?.meta?.measurer?.lastName || recordData()?.meta?.measurer?.firstName) {
                        <span>{{ recordData()?.meta?.measurer?.lastName }} {{ recordData()?.meta?.measurer?.firstName }}</span>
                      } @else {
                        <span i18n="@@common.message.loading">読み込み中</span>
                      }
                    </li>
                  </ul>
                </div>
              </div>

              <div class="content gost-digest-content gost-digest-skeleton__content">
                <div class="left-panel">
                  <div class="gost-digest-skeleton__circle"></div>
                  <div class="gost-digest-skeleton__line gost-digest-skeleton__line--label"></div>
                  <div class="recommend-text-container gost-digest-skeleton__recommend">
                    @for (_ of [1, 2, 3, 4]; track $index) {
                      <div class="gost-digest-skeleton__line gost-digest-skeleton__line--recommend"></div>
                    }
                  </div>
                </div>
                <div class="right-panel gost-digest-skeleton__right">
                  <div class="gost-digest-skeleton__line gost-digest-skeleton__line--section-title"></div>
                  <div class="gost-digest-skeleton__line gost-digest-skeleton__line--description"></div>
                  <div class="gost-digest-skeleton__line gost-digest-skeleton__line--description gost-digest-skeleton__line--description-short"></div>
                  <div class="recommend-card-container">
                    @for (_ of [1, 2, 3, 4]; track $index) {
                      <div class="gost-digest-skeleton__card">
                        <div class="gost-digest-skeleton__line gost-digest-skeleton__line--card-title"></div>
                        <div class="gost-digest-skeleton__line gost-digest-skeleton__line--card-body"></div>
                        <div class="gost-digest-skeleton__line gost-digest-skeleton__line--card-body gost-digest-skeleton__line--card-body-short"></div>
                      </div>
                    }
                  </div>
                </div>
              </div>

              <div class="bottom-panel gost-digest-skeleton__bottom">
                <div class="box">
                  <div class="gost-digest-skeleton__line gost-digest-skeleton__line--section-title"></div>
                  <div class="gost-digest-skeleton__line gost-digest-skeleton__line--description"></div>
                  <div class="gost-digest-skeleton__line gost-digest-skeleton__line--description gost-digest-skeleton__line--description-short"></div>
                  <div class="gost-digest-skeleton__grid">
                    @for (_ of [1, 2, 3, 4, 5, 6, 7, 8, 9]; track $index) {
                      <div class="gost-digest-skeleton__grid-item"></div>
                    }
                  </div>
                </div>
              </div>

              <div class="gost-digest-skeleton__accordion">
                <div class="gost-digest-skeleton__accordion-header">
                  <div class="gost-digest-skeleton__line gost-digest-skeleton__line--accordion-title"></div>
                  <div class="gost-digest-skeleton__line gost-digest-skeleton__line--accordion-desc"></div>
                </div>
                @for (_ of [1, 2, 3]; track $index) {
                  <div class="gost_recording_item">
                    <div class="gost_recording_item_inner">
                      <div class="gost-digest-skeleton__score-row">
                        <div class="gost-digest-skeleton__label"></div>
                        <div class="gost-digest-skeleton__slider">
                          <div class="gost-digest-skeleton__line gost-digest-skeleton__line--slider-head"></div>
                          <div class="gost-digest-skeleton__slider-track"></div>
                          <div class="gost-digest-skeleton__ticks">
                            @for (_ of [1, 2, 3, 4, 5, 6, 7, 8]; track $index) {
                              <span class="gost-digest-skeleton__tick"></span>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
      </div>
    </div>
  } @else if (isLoadingGOSTDataCard() && !isInputMode()) {
    <div class="gost-digest-surface">
          <div class="header">
            <h1 i18n="@@home.gostDigest.title.mealAbilityReport">食事能力のレポート</h1>
            <div class="score_meta">
              <ul class="score_meta_body">
                <li class="score_meta_item score_meta_item--date-nav">
                  <span class="label" i18n="@@home.gostDigest.label.evaluationDate">評価日：</span>
                  <span class="value">{{ asOfDate }}</span>
                  @if (canNavigateOlder || canNavigateNewer) {
                    <span class="date-nav-controls">
                      <button
                        mat-icon-button
                        type="button"
                        class="date-nav-button"
                        [disabled]="!canNavigateOlder"
                        [attr.disabled]="!canNavigateOlder ? '' : null"
                        [class.date-nav-button--disabled]="!canNavigateOlder"
                        (click)="onNavigateOlder()"
                        i18n-aria-label="@@home.gostDigest.button.previousEvaluationDate"
                        aria-label="前の評価日"
                      >
                        <mat-icon fontSet="material-icons-outlined">chevron_left</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        type="button"
                        class="date-nav-button"
                        [disabled]="!canNavigateNewer"
                        [attr.disabled]="!canNavigateNewer ? '' : null"
                        [class.date-nav-button--disabled]="!canNavigateNewer"
                        (click)="onNavigateNewer()"
                        i18n-aria-label="@@home.gostDigest.button.nextEvaluationDate"
                        aria-label="次の評価日"
                      >
                        <mat-icon fontSet="material-icons-outlined">chevron_right</mat-icon>
                      </button>
                    </span>
                  }
                </li>
                <li class="score_meta_item">
                  <span class="label" i18n="@@home.gostDigest.label.evaluator">評価者：</span>
                  <span>{{ recordData()?.meta.measurer.lastName }} {{ recordData()?.meta.measurer.firstName }}</span>
                </li>
              </ul>
            </div>
          </div>
          <!-- 入力モードでは結果表示を非表示 -->
                <div>
                  <div class="content gost-digest-content">
                    <div class="left-panel">
                      <div class="grade-circle">
                        <span>{{ recordData()?.data?.filsGrade }}</span>
                      </div>
                      <div class="grade-text" i18n="@@home.gostDigest.label.estimatedFilsLevel">想定FILSレベル</div>
                      <div class="recommend-text-container">
                        @for (recommendation of recommendations.slice().reverse(); track $index) {
                          <div class="recommend-item">
                            <div class="recommend-item-title">{{ recommendation }}</div>
                            <div class="stars">
                              @if (getRankForRecommendation(recommendation) == 0) {
                                @for (emptyStar of getZeroStarsArray(getRankForRecommendation(recommendation)); track emptyStar) {
                                  <i class="fas fa-star empty"></i>
                                }
                              } @else {
                                @for (star of getStarsArray(getRankForRecommendation(recommendation)); track star) {
                                  <i class="fas fa-star filled"></i>
                                }
                                @for (emptyStar of getEmptyStarsArray(getRankForRecommendation(recommendation)); track emptyStar) {
                                  <i class="fas fa-star empty"></i>
                                }
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="right-panel">
                      <h2 i18n="@@home.gostDigest.title.recommendedFoodFormList">推奨される食形態リスト</h2>
                      <p i18n="@@home.gostDigest.label.foodFormDescription">摂食嚥下の状況と誤嚥リスクを加味して選ばれた食事形態の内容を表示しています。あくまでも目安として、状況に応じて適切に食事形態を調整、組み合わせてください。</p>
                      <div class="card-container">
                        <div class="recommend-card-container">
                          @for (selectedFood of recordData()?.data?.PrimarilySelectedFoods?.selectedFoods.slice().reverse(); track selectedFood) {
                            @if (selectedFood.name !== NA) {
                              <mat-card class="recommend-card" appearance="outlined"
                                [class]="getRankClass(selectedFood.rank)">
                                <mat-card-header>
                                  <mat-card-title class="recommend-card-title">{{ selectedFood.name }}</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                  <p [innerHTML]="convertNewlinesToBr(selectedFood.description)"></p>
                                </mat-card-content>
                              </mat-card>
                            }
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="gost-result-overview__detail-grid">
                  <div class="gost-result-overview__wst-card"
                    [class.gost-result-overview__wst-card--4col]="hasThicknessData">
                    <div class="gost-result-overview__wst-header">
                      <mat-icon fontSet="material-symbols-outlined">local_drink</mat-icon>
                      <span i18n="@@home.gostInfos.wst.title">段階的水飲みテスト</span>
                    </div>
                    <div class="gost-result-overview__wst-table-header">
                      <span i18n="@@home.gostInfos.wst.colWaterAmount">水量</span>
                      <span i18n="@@home.gostInfos.wst.colFirst">1回目</span>
                      <span i18n="@@home.gostInfos.wst.colSecond">2回目</span>
                      @if (hasThicknessData) {
                        <span i18n="@@home.gostInfos.sc.thickened">トロミ</span>
                      }
                    </div>

                    @if (!overviewWstAttemptRows.length) {
                      <div class="gost-result-overview__wst-row">
                        <span>-</span>
                        <span class="gost-result-overview__badge is-default" i18n="@@home.gostInfos.badge.notMeasured">未測定</span>
                        <span class="gost-result-overview__wst-empty">—</span>
                        @if (hasThicknessData) {
                          <span class="gost-result-overview__wst-empty">—</span>
                        }
                      </div>
                    } @else {
                      @for (row of overviewWstAttemptRows; track $index) {
                        <div class="gost-result-overview__wst-row">
                          <span>{{ row.amount != null ? (row.amount + " mL") : "-" }}</span>
                          <div class="gost-result-overview__wst-cell">
                            @if (!row.firstStatus.measured) {
                              <span class="gost-result-overview__badge is-default" i18n="@@home.gostInfos.badge.notMeasured">未測定</span>
                            } @else {
                              <div class="gost-result-overview__wst-main-badges">
                                @if (row.firstStatus.swallowPresent) {
                                  <span class="gost-result-overview__badge is-good" i18n="@@home.gostInfos.badge.swallowPresent">嚥下あり</span>
                                }
                                @if (row.firstStatus.coughPresent) {
                                  <span class="gost-result-overview__badge is-bad" i18n="@@home.gostInfos.badge.coughPresent">せき・むせ</span>
                                }
                                @if (hasOverviewWstCaution(row.firstStatus)) {
                                  <span class="gost-result-overview__badge is-warn" i18n="@@home.gostInfos.badge.caution">注意</span>
                                }
                                @if (
                                  !row.firstStatus.swallowPresent &&
                                  !row.firstStatus.coughPresent &&
                                  !hasOverviewWstCaution(row.firstStatus)
                                ) {
                                  <span class="gost-result-overview__badge is-default" i18n="@@home.gostInfos.badge.noFindings">所見なし</span>
                                }
                              </div>
                            }
                          </div>
                          @if (row.secondStatus; as secondStatus) {
                            <div class="gost-result-overview__wst-cell">
                              @if (!secondStatus.measured) {
                                <span class="gost-result-overview__badge is-default" i18n="@@home.gostInfos.badge.notMeasured">未測定</span>
                              } @else {
                                <div class="gost-result-overview__wst-main-badges">
                                  @if (secondStatus.swallowPresent) {
                                    <span class="gost-result-overview__badge is-good" i18n="@@home.gostInfos.badge.swallowPresent">嚥下あり</span>
                                  }
                                  @if (secondStatus.coughPresent) {
                                    <span class="gost-result-overview__badge is-bad" i18n="@@home.gostInfos.badge.coughPresent">せき・むせ</span>
                                  }
                                  @if (hasOverviewWstCaution(secondStatus)) {
                                    <span class="gost-result-overview__badge is-warn" i18n="@@home.gostInfos.badge.caution">注意</span>
                                  }
                                  @if (
                                    !secondStatus.swallowPresent &&
                                    !secondStatus.coughPresent &&
                                    !hasOverviewWstCaution(secondStatus)
                                  ) {
                                    <span class="gost-result-overview__badge is-default" i18n="@@home.gostInfos.badge.noFindings">所見なし</span>
                                  }
                                </div>
                              }
                            </div>
                          } @else {
                            <span class="gost-result-overview__wst-empty">—</span>
                          }
                          @if (hasThicknessData) {
                            @if (row.thicknessStatus; as thicknessStatus) {
                              <div class="gost-result-overview__wst-cell">
                                @if (!thicknessStatus.measured) {
                                  <span class="gost-result-overview__badge is-default" i18n="@@home.gostInfos.badge.notMeasured">未測定</span>
                                } @else {
                                  <div class="gost-result-overview__wst-main-badges">
                                    @if (thicknessStatus.swallowPresent) {
                                      <span class="gost-result-overview__badge is-good" i18n="@@home.gostInfos.badge.swallowPresent">嚥下あり</span>
                                    }
                                    @if (thicknessStatus.coughPresent) {
                                      <span class="gost-result-overview__badge is-bad" i18n="@@home.gostInfos.badge.coughPresent">せき・むせ</span>
                                    }
                                    @if (hasOverviewWstCaution(thicknessStatus)) {
                                      <span class="gost-result-overview__badge is-warn" i18n="@@home.gostInfos.badge.caution">注意</span>
                                    }
                                    @if (
                                      !thicknessStatus.swallowPresent &&
                                      !thicknessStatus.coughPresent &&
                                      !hasOverviewWstCaution(thicknessStatus)
                                    ) {
                                      <span class="gost-result-overview__badge is-default" i18n="@@home.gostInfos.badge.noFindings">所見なし</span>
                                    }
                                  </div>
                                }
                              </div>
                            } @else {
                              <span class="gost-result-overview__wst-empty">—</span>
                            }
                          }
                        </div>
                      }
                    }
                  </div>

                  <div class="gost-result-overview__risk-card">
                    <div class="gost-result-overview__risk-header">
                      <mat-icon fontSet="material-symbols-outlined">fact_check</mat-icon>
                      <span i18n="@@home.gostInfos.risk.title">質問票の注意項目</span>
                    </div>

                    @if (!overviewRiskItems.length) {
                      <div class="gost-result-overview__risk-empty" i18n="@@home.gostInfos.risk.noItems">該当なし</div>
                    } @else {
                      <div class="gost-result-overview__risk-pills">
                        @for (item of overviewRiskItems; track item.section + item.itemLabel) {
                          <span
                            [class]="'gost-result-overview__risk-pill ' + getOverviewRiskClass(item)"
                            [matTooltip]="item.section + '｜' + item.itemLabel"
                            matTooltipClass="tooltip-wrap"
                            [attr.aria-label]="item.section + ' ' + item.itemLabel + ': ' + item.optionLabel">
                            {{ item.optionLabel }}
                          </span>
                        }
                      </div>
                    }
                  </div>
                </div>
                <mat-accordion class="gost-digest-accordion">
                  <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                    <mat-expansion-panel-header>
                      <mat-panel-title i18n="@@home.gostDigest.title.specificValues">具体的な数値</mat-panel-title>
                      <mat-panel-description i18n="@@home.gostDigest.label.estimatedScores">
                        推定される各スコア
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="gost_recording_item">
                      <div class="gost_recording_item_inner">
                        <dl class="gost_recording_item_set">
                          <dt class="gost_recording_item_head">
                            <div class="label gost-digest-label-wrap" i18n="@@home.gostDigest.label.filsScore">想定摂食嚥下状況（FILS）</div>
                          </dt>
                          <dd class="gost_recording_item_value">
                            @if (recordData()?.data?.filsGrade !== undefined) {
                              <div class="slider-container">
                                <div class="gost-slider-scale-head">
                                  <span i18n="@@home.gostDigest.label.low">低い</span>
                                  <span i18n="@@home.gostDigest.label.high">高い</span>
                                </div>
                                <mat-slider class="gost-readonly-slider" [disabled]="true" [min]="1" [max]="10" [step]="1" [discrete]="true" [showTickMarks]="true" [displayWith]="displayScoreValue">
                                  <input matSliderThumb [value]="sliderValue.FILS" />
                                </mat-slider>
                                <div class="gost-slider-scale-ticks">
                                  @for (scale of FILSSCALE; track scale; let i = $index) {
                                    <span
                                      class="gost-slider-scale-tick"
                                      [style.left.%]="(i * 100) / (FILSSCALE.length - 1)"
                                      [class.gost-slider-scale-tick--start]="i === 0"
                                      [class.gost-slider-scale-tick--end]="i === FILSSCALE.length - 1"
                                    >
                                      {{ scale }}
                                    </span>
                                  }
                                </div>
                              </div>
                            }
                          </dd>
                        </dl>
                      </div>
                    </div>
                    <div class="gost_recording_item">
                      <div class="gost_recording_item_inner">
                        <dl class="gost_recording_item_set">
                          <dt class="gost_recording_item_head">
                            <div class="label gost-digest-label-wrap" i18n="@@home.gostDigest.label.drinkingLevel">水飲みレベル</div>
                          </dt>
                          <dd class="gost_recording_item_value">
                            @if (recordData()?.data?.gostSCData?.level !== undefined) {
                              <div class="slider-container">
                                <div class="gost-slider-scale-head">
                                  <span i18n="@@home.gostDigest.label.poor">不良</span>
                                  <span i18n="@@home.gostDigest.label.good">良好</span>
                                </div>
                                <mat-slider class="gost-readonly-slider" [disabled]="true" [min]="1" [max]="8" [step]="1" [discrete]="true" [showTickMarks]="true" [displayWith]="displayScoreValue">
                                  <input matSliderThumb [value]="sliderValue.SC" />
                                </mat-slider>
                                <div class="gost-slider-scale-ticks">
                                  @for (scale of SCALE; track scale; let i = $index) {
                                    <span
                                      class="gost-slider-scale-tick"
                                      [style.left.%]="(i * 100) / (SCALE.length - 1)"
                                      [class.gost-slider-scale-tick--start]="i === 0"
                                      [class.gost-slider-scale-tick--end]="i === SCALE.length - 1"
                                    >
                                      {{ scale }}
                                    </span>
                                  }
                                </div>
                              </div>
                            }
                          </dd>
                        </dl>
                      </div>
                    </div>
                    <div class="gost_recording_item">
                      <div class="gost_recording_item_inner">
                        <dl class="gost_recording_item_set">
                          <dt class="gost_recording_item_head">
                            <div class="label gost-digest-label-wrap" i18n="@@home.gostDigest.label.aspirationRisk">誤嚥リスク</div>
                          </dt>
                          <dd class="gost_recording_item_value">
                            @if (recordData()?.data?.gostLevel !== undefined) {
                              <div class="slider-container">
                                <div class="gost-slider-scale-head">
                                  <span i18n="@@home.gostDigest.label.low">低い</span>
                                  <span i18n="@@home.gostDigest.label.high">高い</span>
                                </div>
                                <mat-slider class="gost-readonly-slider" [disabled]="true" [min]="1" [max]="8" [step]="1" [discrete]="true" [showTickMarks]="true" [displayWith]="displayScoreValue">
                                  <input matSliderThumb [value]="sliderValue.GOST" />
                                </mat-slider>
                                <div class="gost-slider-scale-ticks">
                                  @for (scale of SCALE; track scale; let i = $index) {
                                    <span
                                      class="gost-slider-scale-tick"
                                      [style.left.%]="(i * 100) / (SCALE.length - 1)"
                                      [class.gost-slider-scale-tick--start]="i === 0"
                                      [class.gost-slider-scale-tick--end]="i === SCALE.length - 1"
                                    >
                                      {{ scale }}
                                    </span>
                                  }
                                </div>
                              </div>
                            }
                          </dd>
                        </dl>
                      </div>
                    </div>
                    @if (showDssScore) {
                      <div class="gost_recording_item">
                        <div class="gost_recording_item_inner">
                          <dl class="gost_recording_item_set">
                            <dt class="gost_recording_item_head">
                              <div class="label gost-digest-label-wrap" i18n="@@home.gostDigest.label.dssScore">推定嚥下障害重症度（DSS）</div>
                            </dt>
                            <dd class="gost_recording_item_value">
                              @if (recordData()?.data?.dss !== undefined) {
                                <div class="slider-container">
                                  <div class="gost-slider-scale-head">
                                    <span i18n="@@home.gostDigest.label.low">低い</span>
                                    <span i18n="@@home.gostDigest.label.high">高い</span>
                                  </div>
                                  <mat-slider class="gost-readonly-slider" [disabled]="true" [min]="1" [max]="8" [step]="1" [discrete]="true" [showTickMarks]="true" [displayWith]="displayScoreValue">
                                    <input matSliderThumb [value]="sliderValue.DSS" />
                                  </mat-slider>
                                  <div class="gost-slider-scale-ticks">
                                    @for (scale of SCALE; track scale; let i = $index) {
                                      <span
                                        class="gost-slider-scale-tick"
                                        [style.left.%]="(i * 100) / (SCALE.length - 1)"
                                        [class.gost-slider-scale-tick--start]="i === 0"
                                        [class.gost-slider-scale-tick--end]="i === SCALE.length - 1"
                                      >
                                        {{ scale }}
                                      </span>
                                    }
                                  </div>
                                </div>
                              }
                            </dd>
                          </dl>
                        </div>
                      </div>
                    }
                  </mat-expansion-panel>
                </mat-accordion>
    </div>
  }
</section>
}
